import script from "./ExamCreationFromStock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamCreationFromStock.vue?vue&type=script&setup=true&lang=ts"

import "./ExamCreationFromStock.vue?vue&type=style&index=0&id=6d244473&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d244473"]])

export default __exports__